import { IStore } from '../types/IStore';

export const notificationsCount = (state: IStore) => state.notifications?.count;
export const notificationsList = (state: IStore) => state.notifications.notificationsList
export const initialNotification = (state:IStore) => state.notifications.initialNotification;
export const getNotificationState = (state:IStore) => state.notifications.notificationState;
export const getClickedNotification = (state: IStore) => state.notifications.clickedNotification;